import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SatModal from '@components/common/satUI/SatModal';
import {
  setChannelInfo,
  renewChannelToken,
  setIsChannelSelected,
} from '@store/actions/userAction';

// @NOTE: 태블릿/모바일 로직 통일을 위해
// 모바일의 stateSelector 처럼 Reducer Selector 별도 분리
const stateSelector = state => ({
  ...state.userReducer,
  ...state.commonReducer,
});

let initialChannelCode = null;

const HomeMainChannelPopup = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const {
    codeInfo,
    tokenInfo,
    channelInfo,
    multiChannelList,
    isChannelSelected,
  } = useSelector(stateSelector);

  const [selectedChannel, setSelectedChannel] = useState(null);
  const [channelSelectPromise, setChannelSelectPromise] = useState(null);
  const [isShowChannelSelect, setIsShowChannelSelect] = useState(false);

  useEffect(() => {
    if (selectedChannel && typeof channelSelectPromise === 'function')
      channelSelectPromise(selectedChannel);
  }, [selectedChannel]);

  const showChannelSelect = () =>
    new Promise(resolve => {
      setChannelSelectPromise(() => resolve);
      setIsShowChannelSelect(true);
    });

  const checkUserChannel = async () => {
    // 채널 정보가 이미 세팅 된 경우 다시 세팅하지 않음
    if (isChannelSelected) return;

    let userChannelCode = tokenInfo?.orgChnlCd;

    const isMultiChannel = multiChannelList.length >= 2;
    const isOnlyOneChannel = multiChannelList.length === 1;
    const isUserSameChannel = $utils.checkUserSameChannel(
      multiChannelList,
      tokenInfo,
    );

    // 유저가 선택 가능한 채널이 2개 이상인 경우, 채널 선택 팝업 노출
    if (isMultiChannel) {
      userChannelCode = await showChannelSelect();
    }

    // 선택 가능한 채널이 1개일 때 본인 채널과 다른 경우, 채널 정보 재세팅
    else if (isOnlyOneChannel && !isUserSameChannel) {
      const myChannelInfo = multiChannelList[0];
      userChannelCode = myChannelInfo.cdVal;
    }

    // 선택되거나, 변경된 채널이 유저의 토큰 채널과 다르면 로그인 토큰 재세팅
    if (userChannelCode !== tokenInfo?.orgChnlCd) {
      await renewUserToken(userChannelCode);
    }

    // 채널 선택/세팅 완료
    dispatch(setIsChannelSelected(true));
    onClose();
  };

  const renewUserToken = channelCode => {
    const payload = { multiChnlCd: channelCode };
    dispatch(renewChannelToken(payload));
    handleChangeChannel(channelCode);
  };

  const handleChangeChannel = channelCode => {
    const channelList = codeInfo['totalChannelCodes'] || [];
    const channelInfo =
      channelList?.find(channel => channel.cdVal === channelCode) || {};
    dispatch(setChannelInfo(channelInfo));
  };

  const selectChannel = channelCode => {
    const selectedChannelCode = channelCode || channelInfo.cdVal;
    setSelectedChannel(selectedChannelCode);
  };

  // 유저 토큰에 설정된 최초 채널 / 유저가 선택한 채널 확인 후 세팅
  useEffect(() => {
    if (!$utils.isNil(multiChannelList)) checkUserChannel();
  }, [tokenInfo, codeInfo.totalChannelCodes, multiChannelList]);

  /* 해당 유저가 다중 채널 사용 가능자 일 때만 채널 선택 모달 노출 */
  return isShowChannelSelect ? (
    <SatModal visible={isOpen}>
      <header className="modal-header">
        <h3 className="layer-tit2">채널 선택</h3>
      </header>

      <div className="cont">
        <div className="search-wrap">
          <ul className="list">
            {multiChannelList.map(({ cdVal, cmnCdNm }, index) => (
              <li
                key={index}
                className={cdVal === channelInfo?.cdVal ? 'active' : ''}
                onClick={() => selectChannel(cdVal)}
              >
                <span className="user-info">{cmnCdNm}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </SatModal>
  ) : (
    <></>
  );
};

HomeMainChannelPopup.propTypes = {
  isOpen: $propTypes.bool,
  onClose: $propTypes.func,
  onStopDisplay: $propTypes.func,
};

export default HomeMainChannelPopup;
